import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ComponentLoader } from 'cat-ecommerce-alloy';
import AddEquipmentCTA from '../../../../components/common/myEquipmentHeader/equipmentPanel/AddEquipmentCTA';
import SelectEquipmentCTA from '../../../../components/common/myEquipmentHeader/equipmentPanel/SelectEquipmentCTA';
import { IS_PM } from '../../../../constants/commonConstants';
import PMKitWidget from '../PMKitWidget/PMKitWidget';

const PMKitCTA = ({
  selectedEquipment,
  myEquipmentList,
  widgetIdentifier,
  isCampaignLandingPage,
  isMachineLandingPage,
  openAddDrawer,
  openEditDrawer
}) => {
  const [t] = useTranslation();
  const storeId = useSelector(s => s.common?.storeId);
  const isLoading = useSelector(s => s.myEquipment?.isLoading);
  const initialLoading = useSelector(s => s.myEquipment?.initialLoading);
  const serialNumValidationStatus = useSelector(
    state => state.myEquipment?.serialNumValidationStatus
  );
  const getPMKitCTAWidget = () => {
    if (
      (isLoading && serialNumValidationStatus !== 'pending') ||
      initialLoading
    ) {
      return <ComponentLoader />;
    } else if (!selectedEquipment?.model) {
      if (myEquipmentList.length === 0) {
        return (
          <>
            <h2 className="h2 display-3 mb-5">
              {isCampaignLandingPage
                ? t('PM_CAMPAIGN_WIDGET')
                : t('PM_KIT_UI1')}
            </h2>
            <AddEquipmentCTA
              storeId={storeId}
              widgetIdentifier={widgetIdentifier}
              isPM={IS_PM}
            />
          </>
        );
      } else {
        return (
          <>
            <h2 className="h2 display-3 mb-5">
              {isCampaignLandingPage
                ? t('PM_CAMPAIGN_WIDGET')
                : t('PM_KIT_UI1')}
            </h2>
            <SelectEquipmentCTA
              selectedEquipment={selectedEquipment}
              myEquipmentList={myEquipmentList}
              isPM={IS_PM}
              openAddDrawer={openAddDrawer}
            />
          </>
        );
      }
    } else {
      return (
        <PMKitWidget
          selectedEquipment={selectedEquipment}
          myEquipmentList={myEquipmentList}
          storeId={storeId}
          widgetIdentifier={widgetIdentifier}
          isCampaignLandingPage={isCampaignLandingPage}
          isMachineLandingPage={isMachineLandingPage}
          openAddDrawer={openAddDrawer}
          openEditDrawer={openEditDrawer}
        />
      );
    }
  };

  return (
    <div className="container p-0 py-4" data-testid="pm-kit-cta">
      {getPMKitCTAWidget()}
    </div>
  );
};

PMKitCTA.propTypes = {
  myEquipmentList: PropTypes.arrayOf(
    PropTypes.objectOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string]))
  ),
  selectedEquipment: PropTypes.shape({
    unValidatedEquipmentId: PropTypes.string,
    model: PropTypes.string,
    assetId: PropTypes.string,
    productId: PropTypes.string,
    equipmentFamily: PropTypes.string,
    uniqueIndex: PropTypes.string,
    serialNumber: PropTypes.string,
    validatedAsset: PropTypes.bool,
    imageURL: PropTypes.string
  }),
  widgetIdentifier: PropTypes.string,
  isCampaignLandingPage: PropTypes.bool,
  isMachineLandingPage: PropTypes.bool,
  openAddDrawer: PropTypes.func,
  openEditDrawer: PropTypes.func
};

export default PMKitCTA;
